<template>
  <div>
    <el-row class="wenzi">账户中心</el-row>
    <el-row class="wenzi-main">
      <el-col :span="3" class="acc-left">
        <router-link class="link2" :to="'/AccountCenter/BasicInformation'"
          >基本信息</router-link
        >
        <!-- <router-link class="link2" :to="'/AccountCenter/StaffAccount'"
          >员工账号</router-link
        > -->
        <router-link class="link2" :to="'/AccountCenter/RealnameAuthentication'"
          >实名认证</router-link
        >
        <router-link class="link2" :to="'/AccountCenter/FinancialInformation'"
          >财务信息</router-link
        >
        <router-link class="link2" :to="'/AccountCenter/RechargeManagement'"
          >充值管理</router-link
        >
        <router-link class="link2" :to="'/AccountCenter/Invoiceinformation'"
          >{{ isOrganization ? '发票信息与经办人' : '开票信息' }}</router-link
        >
      </el-col>
      <el-col :span="21">
        <!-- 信息内容 -->
        <router-view />
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: "DCIRegistration",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {};
  },
  computed: {
    isOrganization() {
      const realInformation = this.$store.state.realInformation || {};
      return Boolean(realInformation.legalPersonCertName);
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.home-zz {
}
.wenzi {
  height: 80px;
  margin-left: 50px;
  text-align: center;
  line-height: 80px;

  letter-spacing: normal;
  color: #333333;
  text-align: left;
  font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 20px;
  white-space: nowrap;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-feature-settings: "kern";
  font-kerning: normal;
}
.wenzi-main {
  margin-left: 60px;
}
.acc-left {
  border-right: 1px solid #797979;
  height: 800px;

  .link2 {
    display: block;
    line-height: 60px;
    padding: 0 15px;
    letter-spacing: normal;
    color: #333333;
    font-size: 18px;
    text-align: left;
    font-family: "Arial Negreta", "Arial Normal", "Arial", sans-serif;
    font-weight: 700;
    font-style: normal;
    cursor: pointer;
    white-space: nowrap;
    text-transform: none;
    text-rendering: optimizeLegibility;
    -webkit-font-feature-settings: "kern";
    font-kerning: normal;
    transition: all 0.3s;

    &:hover {
      color: #409EFF;
      background-color: #f5f7fa;
    }

    &.router-link-active {
      color: #409EFF;
      background-color: #ecf5ff;
      border-left: 3px solid #409EFF;
    }
  }
}

</style>
